class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.variantId = this.querySelector("#variantId");
    this.quantity = this.querySelector("#productQuantity");
    this.atcButton = this.querySelector("button[data-action='add-to-cart']");
    this.productJson = JSON.parse(
      this.querySelector("script[data-product-json]").textContent,
    );
    this.productVariantStocksJson = JSON.parse(
      this.querySelector("[data-product-variant-stocks]").textContent,
    );

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.addEventListener("VariantChange", () => {
      this.onVariantChangeHandler(this);
    });

    this.productSlideshow = document.querySelector("product-slideshow");
  }

  onSubmitHandler(e) {
    e.preventDefault();

    this.quantity = this.querySelector("#productQuantity");
    this.atcButton = this.querySelector("button[data-action='add-to-cart']");

    this.variantId = this.querySelector("#variantId");

    this.atcButton?.setAttribute("data-loading", "true");

    const currentVariantId = parseInt(this.variantId.value);
    const currentQuantity = parseInt(this.quantity.value);

    const sellingPlanInput = this.querySelector("input[name='selling_plan']");
    const sellingPlanValue = sellingPlanInput?.value;

    const item = {
      id: currentVariantId,
      quantity: currentQuantity,
    };

    if (sellingPlanValue) {
      item.selling_plan = sellingPlanValue;
    }

    const formData = {
      items: [item],
    };

    const config = fetchConfig();
    config.body = JSON.stringify(formData);

    fetch(window.Shopify.routes.root + "cart/add.js", config)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          console.log(response);
          this.error = true;
          alert(response.message + ": " + response.description);
          return;
        } else {
          openCartDrawerV2();
        }
      })
      .catch((e) => {
        alert("An error occured while adding product to cart.");
        console.error(e);
      })
      .finally(() => {
        this.atcButton?.setAttribute("data-loading", "false");
      });
  }

  getCurrentActiveVariant() {
    const currentSelectedOptions = Array.from(
      this.querySelectorAll("product-form-options input:checked"),
    ).map((item) => item.value);

    const matchingVariant = this.productJson.variants.find((variant) => {
      let variantMatch = true;
      for (let i = 0; i < currentSelectedOptions.length; i++) {
        const currentOption = currentSelectedOptions[i];
        const key = "option" + (i + 1);
        if (variant[key] !== currentOption) {
          variantMatch = false;
        }
      }
      return variantMatch;
    });

    return matchingVariant;
  }

  async onVariantChangeHandler(event) {
    const variant = this.getCurrentActiveVariant();

    this.variantId.value = variant.id;

    const fetchSection = await this.fetchSection();
    const newPriceWrapper = fetchSection.querySelector(
      ".template-product__info-row-price",
    );
    const currentPriceWrapper = document.querySelector(
      ".template-product__info-row-price",
    );

    this.productSlideshow.dispatchEvent(
      new CustomEvent("updateImages", { detail: variant.id }),
    );

    currentPriceWrapper.innerHTML = newPriceWrapper?.innerHTML;

    this.handleStock(variant);

    // Show/hide subscription blocks for the active variant
    this.querySelectorAll("select-subscription").forEach((el) => {
      el.style.display =
        el.dataset.variantId === String(variant.id) ? "" : "none";
      // Reset to no subscription
      const noSubRadio = el.querySelector('input[value="false"]');
      if (noSubRadio) noSubRadio.checked = true;
    });
    // Reset selling plan input
    const sellingPlanInput = this.querySelector("input[name='selling_plan']");
    if (sellingPlanInput) sellingPlanInput.value = "";

    const variantBottom = document.querySelector(
      ".product-form__cta-container",
    );
    variantBottom.innerHTML = fetchSection.querySelector(
      ".product-form__cta-container",
    )?.innerHTML;

    const variantOverlay = document.querySelector(
      `variant-overlay[data-product-id="${this.productJson.id}"][data-sticky="true"]`,
    );
    if (variantOverlay) {
      variantOverlay.selectVariant(variant.id);
      // The add-to-cart button the sticky overlay watches was just replaced
      // along with the rest of .product-form__cta-container.
      variantOverlay.observeProductFormAtc();
    }
  }

  async fetchSection() {
    const variant = this.getCurrentActiveVariant();
    const url = new URL(window.location.href);
    url.searchParams.set("section_id", this.dataset.sectionId);
    url.searchParams.set("variant", variant.id);
    const fetchRes = await fetch(url);
    const html = await fetchRes.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc;
  }

  handleStock(variant) {
    if (this.atcButton) {
      this.atcButton.disabled = !variant.available;
    }

    //Set current quantity to 1. Different variants can have different quantities. This does not automatically updates the maxQuantity of the input#
    if (this.quantity) {
      this.quantity.value = "1";
    }

    // INventory progressbar
    const progressBarEl = this.querySelector("product-progress-bar");
    const progressBar = this.querySelector(".product-progress-bar__progress");
    const productField = this.querySelector(".product-progress-bar__products");
    const deliveryInfo = this.querySelector(".product-progress-bar__delivery");

    const inventoryQuantity = this.productVariantStocksJson[variant.id];

    if (inventoryQuantity == 0) {
      productField.textContent = progressBarEl.dataset.soonAvailable;
      deliveryInfo.classList.add("hidden");
    } else if (inventoryQuantity < 11) {
      productField.textContent = `${
        progressBarEl.dataset.productOnly
      } ${inventoryQuantity}
          ${
            inventoryQuantity == 1
              ? progressBarEl.dataset.productAvailable
              : progressBarEl.dataset.productsAvailable
          }`;
      deliveryInfo.classList.remove("hidden");
    } else {
      productField.textContent = progressBarEl.dataset.immediatelyAvailable;
      deliveryInfo.classList.remove("hidden");
    }

    progressBar.setAttribute("data-low-stock", inventoryQuantity < 11);
    progressBar.value = inventoryQuantity;
  }
}

customElements.define("product-form", ProductForm);

console.log("Product form loaded");

class SelectSubscription extends HTMLElement {
  constructor() {
    super();

    this.sellingPlanInputs = document.querySelectorAll(
      "input[name='selling_plan']",
    );
  }

  connectedCallback() {
    this.addEventListener("change", () => {
      const purchaseOption = this.querySelector(
        'input[name="Select-Purchase-Option"]:checked',
      );
      let newSellingPlanValue = null;
      if (purchaseOption?.value === "true") {
        const sellingPlanSelect = this.querySelector(
          'select[name="selling-plan"]',
        );
        newSellingPlanValue = sellingPlanSelect?.value;
      }
      this.sellingPlanInputs.forEach((sellingPlanInput) => {
        sellingPlanInput.value = newSellingPlanValue;
      });
    });
  }
}

customElements.define("select-subscription", SelectSubscription);

class ProductFormOptions extends HTMLElement {
  constructor() {
    super();

    this.currentActiveInput = this.querySelector(
      "[data-product-option][data-active='true']",
    );

    //For color swatch
    this.colorSwatchList = this.querySelector("[data-color-swatch-list]");
    this.isColorSwatch = this.colorSwatchList != null;
    this.currentSwatchVariant = this.querySelector("[data-current-variant]");
    this.currentColorSwatch = this.querySelector("[data-current-color-swatch]");

    this.querySelector("[data-color-swatch-label]")?.addEventListener(
      "click",
      () => {
        this.toggleColorSwatchOptions();
      },
    );
    this.querySelector("[data-color-swatch-label]")?.addEventListener(
      "keydown",
      (e) => {
        if (e.key === "Enter") {
          this.toggleColorSwatchOptions();
        }
      },
    );
    this.querySelectorAll(".choices__item--selectable").forEach((item) => {
      item.addEventListener("click", () => {
        this.handleColorSwatchClick(item);
      });
      item.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          this.handleColorSwatchClick(item);
        }
      });
    });

    this.renderStellaIcon();
  }

  connectedCallback() {
    this.querySelectorAll("[data-product-option]").forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleChangeOption(item);
      });
      item.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          this.handleChangeOption(item);
        }
      });
    });
  }

  renderStellaIcon() {
    if (!userDidStellaQuiz()) {
      return;
    }

    this.querySelectorAll("[data-stella-selected]").forEach((stellaEl) => {
      const variantId = stellaEl.dataset.variantId;
      if (variantIdRecommendedByStella(variantId)) {
        stellaEl.dataset.stellaSelected = "true";
      }
    });
  }

  handleChangeOption(item) {
    this.querySelectorAll(".choices__item--selectable").forEach((item) =>
      item.classList.remove("is-highlighted"),
    );
    this.currentActiveInput.querySelector("input").checked = false;
    this.currentActiveInput.setAttribute("data-active", "false");

    this.currentActiveInput = item;

    this.querySelector(
      `.choices__item--selectable[data-variant-id="${item.getAttribute(
        "data-variant-id",
      )}"]`,
    )?.classList.add("is-highlighted");
    this.currentActiveInput.querySelector("input").checked = true;
    this.currentActiveInput.setAttribute("data-active", "true");

    if (this.isColorSwatch) {
      this.updateColorSwatchLabel(item.querySelector("input").value);
    }

    console.log(this.closest("product-form"));
    console.log("prod form");

    this.closest("product-form")?.dispatchEvent(
      new CustomEvent("VariantChange", {
        bubbles: true,
      }),
    );
  }

  handleColorSwatchClick(item) {
    const variantId = item.getAttribute("data-variant-id");
    const correspondingVariantInput = this.querySelector(
      `[data-option-swatch][data-variant-id='${variantId}']`,
    );
    this.toggleColorSwatchOptions();
    this.handleChangeOption(correspondingVariantInput);
  }

  updateColorSwatchLabel(optionTitle) {
    this.currentSwatchVariant.textContent = optionTitle;
    //  + ' - ' + formatPrice(variant.price);
    this.currentColorSwatch.removeAttribute("class");

    const colorSwatchName = optionTitle.toLowerCase().replaceAll(" ", "-");

    this.currentColorSwatch.classList.add("swatch");
    this.currentColorSwatch.classList.add("swatch--" + colorSwatchName);
    this.currentColorSwatch.setAttribute(
      "style",
      this.currentActiveInput.querySelector("label").getAttribute("style"),
    );

    const stellaElItemSingle = this.querySelector(
      ".choices__list--single .product-options__swatch-list-item-stella",
    );
    stellaElItemSingle.dataset.stellaSelected = variantIdRecommendedByStella(
      this.currentActiveInput.dataset.variantId,
    );
  }

  toggleColorSwatchOptions() {
    this.colorSwatchList.classList.toggle("is-active");
  }
}

customElements.define("product-form-options", ProductFormOptions);
